import { render, staticRenderFns } from "./AiCaseIndicator.vue?vue&type=template&id=796a6046&scoped=true&"
import script from "./AiCaseIndicator.vue?vue&type=script&lang=js&"
export * from "./AiCaseIndicator.vue?vue&type=script&lang=js&"
import style0 from "./AiCaseIndicator.vue?vue&type=style&index=0&id=796a6046&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796a6046",
  null
  
)

export default component.exports